import { AlertModal } from 'ui-components';

interface Props {
  hasUnsavedChanges: boolean;
  keepEditing: () => void;
  leavePage: () => void;
}

export const ConfirmChanges: React.FC<Props> = ({
  hasUnsavedChanges,
  keepEditing,
  leavePage,
}) => (
  <AlertModal
    isOpen={hasUnsavedChanges}
    title="Are you sure you want to leave?"
    cancelButtonProps={{
      onClick: keepEditing,
      title: 'Stay',
    }}
    acceptButtonProps={{
      onClick: leavePage,
      title: 'Leave',
    }}
    onClose={leavePage}
    closeOnEsc={false}
    closeOnOverlayClick={false}
  >
    Your changes may not be saved.
  </AlertModal>
);
